import React from 'react';
import './Careers.css';
import Footer from './Footer';
import { Link } from 'react-router-dom';

const Careers = () => {
    return (
        <div>

            <div className="container mt-5">
                <div className="container">
                    <p className="imp_note">Note: Since this platform is free for all students, if you would want to complete an internship, it will not be compensated; nevertheless, you will have the opportunity to join the Quicklearn team after your internship is over.</p>
                </div>

                <br /><br />

                <h1>Careers at Quicklearn</h1>
                <p>Explore exciting career opportunities at Quicklearn. We are always looking for talented individuals to join our team.</p>

                <h2 className="mt-5">Current Openings</h2>
                <div className="row row-cols-1 row-cols-md-3">
                    <div className="col">
                        <div className="card">
                            <div className="card-body" style={{height:'fit-content'}}>
                                <h5 className="card-title" style={{textAlign:'left'}}>Graphic Designers Intern</h5> <br />
                                <p className="card-text" style={{textAlign:'left', marginLeft:'-8px', fontSize:'15px'}}>Work from home (1/2/3 months)<br />
                                <Link to="/Job1">
                                    <button className="btn btn-primary">Apply Now</button>
                                </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card">
                            <div className="card-body" style={{height:'fit-content'}}>
                                <h5 className="card-title" style={{textAlign:'left'}}>Campus Ambassador Intern</h5> <br />
                                <p className="card-text" style={{textAlign:'left', marginLeft:'-8px', fontSize:'15px'}}>Work from home (1/2/3 months)<br />
                                <Link to="/Job2">
                                    <button className="btn btn-primary">Apply Now</button>
                                </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card">
                            <div className="card-body" style={{height:'fit-content'}}>
                                <h5 className="card-title" style={{textAlign:'left'}}>HR Intern</h5> <br />
                                <p className="card-text" style={{textAlign:'left', marginLeft:'-8px', fontSize:'15px'}}>Work from home (1/2/3 months)<br />
                                <Link to="/Job3">
                                    <button className="btn btn-primary">Apply Now</button>
                                </Link> 
                                    </p>  
                            </div>
                        </div>
                    </div>
                </div>

                <br /><br />                <br /><br />
                <div className="row">
                    <div className="col-md-6">
                        <h2>Why Join Us?</h2>
                        <p className="join_us">Join QuickLearn to become part of a vibrant educational community dedicated to empowering learners worldwide. At QuickLearn, we strive to make quality education accessible to all, fostering a culture of learning excellence and academic achievement.</p>
                        <p className="join_us">By joining our platform, you gain access to a vast array of educational resources, expertly curated to support your academic journey. Whether you're a student, educator, or lifelong learner, QuickLearn offers the tools and support you need to succeed."</p>
                    </div>
                </div>
            </div>

            <br /><br /><br /> <br />
            <hr/>
            <Footer/>
        </div>
    );
}

export default Careers;
